import Pipeline from "../Pipeline";
import { ICompose, ActionItem, Action } from "../types";
import sdkCompose from "./SDKCompose";
import EventCompose from "./Compose";

export default class Compose extends Pipeline<Event | EventCompose | ActionItem>
    implements ICompose {
    process(e: Event | EventCompose | ActionItem): Action {
        return sdkCompose(e);
    }

    add(item: ActionItem): void {
        this.push(item);
    }
}
